/**
 * Subscription Tab Access Configuration
 *
 * Controls which employee departments/roles can see the "Subscriptions" tab
 * on the user detail page (/dashboard/:id).
 *
 * Edit the arrays below to change gating:
 * - departments: department titles that can see the tab (case-insensitive match)
 * - roles: role titles that can see the tab (case-insensitive match)
 *
 * Rules (same as accessControl.js):
 * - Empty arrays mean no restriction (all logged-in users with dashboard access can see the tab).
 * - Executive department has full access by default and does not need to be listed.
 */

export const SUBSCRIPTION_TAB_ACCESS = {
  departments: [], // Empty = no restriction; all users with dashboard access can see the tab
  roles: [],
};
